module.exports = __webpack_public_path__ + "static/media/jurisPro.3709ec6d.png";